import { RefreshAuth, ChangedPasswordVM, IdentityUser } from '../../../models/auth';
import { HttpParams } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { HideLoader, ShowLoader } from 'src/app/shared/decorators/loader';
import { IJwtoken } from '../../../models/jwtoken';

export const AUTHENTICATE = 'AUTHENTICATE';
export const COGNITOAUTHENTICATE = 'COGNITOAUTHENTICATE';
export const AUTHENTICATE_SUCCESS = 'AUTHENTICATE_SUCCESS';
export const AUTHENTICATE_FAIL = 'AUTHENTICATE_FAIL';
export const UNIVERSAL_LOGIN_AUTHENTICATE = 'UNIVERSAL_LOGIN_AUTHENTICATE';


export const ASSUME_USER_INIT = 'ASSUME_USER_INIT';
export const ASSUME_USER = 'ASSUME_USER';
export const ASSUME_USER_SUCCESS = 'ASSUME_USER_SUCCESS';
export const ASSUME_USER_FAIL = 'ASSUME_USER_FAIL';

export const GET_IDENTITY_USERS = 'GET_IDENTITY_USERS';
export const GET_IDENTITY_USERS_FAIL = 'GET_IDENTITY_USERS_FAIL';
export const SET_IDENTITY_USERS = 'SET_IDENTITY_USERS';

export const AUTHENTICATE_TFA_INIT = 'AUTHENTICATE_TFA_INIT';
export const AUTHENTICATE_TFA = 'AUTHENTICATE_TFA';
export const AUTHENTICATE_TFA_SUCCESS = 'AUTHENTICATE_TFA_SUCCESS';
export const AUTHENTICATE_TFA_FAIL = 'AUTHENTICATE_TFA_FAIL';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export const REQUEST_RESET_INIT = 'REQUEST_RESET_INIT';
export const REQUEST_RESET = 'REQUEST_RESET_PASSWORD';
export const REQUEST_RESET_SUCCESS = 'REQUEST_RESET_SUCCESS';
export const REQUEST_RESET_FAIL = 'REQUEST_RESET_FAIL';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';
export const CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD_RESET';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export class Authenticate implements Action {
    readonly type = AUTHENTICATE;
    readonly payload: { username: string, password: string };
    constructor(username: string, password: string) {
        this.payload = { username, password };
    }
}

export class CognitoAuthenticate implements Action {
    readonly type = COGNITOAUTHENTICATE;
    readonly payload: { token: IJwtoken };

  constructor(token: IJwtoken) {
        this.payload = { token };
    }
}

export class AuthenticateSuccess implements Action {
    readonly type = AUTHENTICATE_SUCCESS;
    readonly payload: { hasFalseInception: boolean };
    constructor(hasFalseInception: boolean) {
        this.payload = { hasFalseInception };
    }
}

export class AuthenticateFail implements Action {
    readonly type = AUTHENTICATE_FAIL;
    constructor(readonly payload: string) { }
}

export class AssumeUserInit implements Action {
    readonly type = ASSUME_USER_INIT;
}

export class AssumeUser implements Action {
    readonly type = ASSUME_USER;
    readonly payload: { userId: number, tfaCode?: string };
    constructor(userId: number, tfaCode?: string) {
        this.payload = {
            userId,
            tfaCode
        };
     }
}

export class AssumeUserSuccess implements Action {
    readonly type = ASSUME_USER_SUCCESS;
    readonly payload: { hasFalseInception: boolean };
    constructor(hasFalseInception: boolean) {
        this.payload = { hasFalseInception };
    }
}

export class UniversalLoginAuthenticate implements Action {
    readonly type = UNIVERSAL_LOGIN_AUTHENTICATE;
    readonly payload: { token: IJwtoken };
    constructor(token: IJwtoken) {
        this.payload = { token };
    }
}

export class AssumeUserFail implements Action {
    readonly type = ASSUME_USER_FAIL;
    constructor(readonly payload: string) { }
}

export class GetIdentityUsers implements Action {
    readonly type = GET_IDENTITY_USERS;
}

export class SetIdentityUsers implements Action {
    readonly type = SET_IDENTITY_USERS;
    constructor(readonly payload: IdentityUser[]) { }
}

export class GetIdentityUsersFail implements Action {
    readonly type = GET_IDENTITY_USERS_FAIL;
    constructor(readonly payload: string) {}
}

export class AuthenticateTFAInit implements Action {
    readonly type = AUTHENTICATE_TFA_INIT;
}

export class AuthenticateTFA implements Action {
    readonly type = AUTHENTICATE_TFA;
    readonly payload: { username: string, password: string, tfaCode: string };
    constructor(username: string, password: string, tfaCode: string) {
        this.payload = { username, password, tfaCode };
    }
}

export class AuthenticateTFASuccess implements Action {
    readonly type = AUTHENTICATE_TFA_SUCCESS;
    readonly payload: { hasFalseInception: boolean };
    constructor(hasFalseInception: boolean) {
        this.payload = { hasFalseInception };
    }
}

export class AuthenticateTFAFail implements Action {
    readonly type = AUTHENTICATE_TFA_FAIL;
    constructor(readonly payload: string) { }
}

export class RefreshToken implements Action {
    readonly type = REFRESH_TOKEN;
    constructor(public payload: RefreshAuth) { }
}

@ShowLoader()
export class ResetPassword implements Action {
    readonly type = RESET_PASSWORD;
    constructor(public payload: HttpParams) { }
}

@HideLoader(RESET_PASSWORD)
export class ResetPasswordSuccess implements Action {
    readonly type = RESET_PASSWORD_SUCCESS;
}

@HideLoader(RESET_PASSWORD)
export class ResetPasswordFail implements Action {
    readonly type = RESET_PASSWORD_FAIL;
    constructor(public payload: string) { }
}
export class RequestResetInit implements Action {
    readonly type = REQUEST_RESET_INIT;
}

@ShowLoader()
export class RequestReset implements Action {
    readonly type = REQUEST_RESET;
    constructor(public payload: {}) { }
}

@HideLoader(REQUEST_RESET)
export class RequestResetPasswordFail implements Action {
    readonly type = REQUEST_RESET_FAIL;
    constructor(public payload: string) { }
}

@HideLoader(REQUEST_RESET)
export class RequestResetPasswordSuccess implements Action {
    readonly type = REQUEST_RESET_SUCCESS;
}

@ShowLoader()
export class ChangePassword implements Action {
    readonly type = CHANGE_PASSWORD;
    constructor(public payload: ChangedPasswordVM) { }
}

@HideLoader(CHANGE_PASSWORD)
export class ChangePasswordSuccess implements Action {
    readonly type = CHANGE_PASSWORD_SUCCESS;
    constructor(public payload: string) { }
}

@HideLoader(CHANGE_PASSWORD)
export class ChangePasswordFail implements Action {
    readonly type = CHANGE_PASSWORD_FAIL;
    constructor(public payload: string) { }
}
export class ChangePasswordReset implements Action {
    readonly type = CHANGE_PASSWORD_RESET;
}

@ShowLoader()
export class Logout implements Action {
    readonly type = LOGOUT;
}
@HideLoader(LOGOUT)
export class LogoutSuccess implements Action {
    readonly type = LOGOUT_SUCCESS;
}

export type AuthActions
    = Authenticate | AuthenticateSuccess | AuthenticateFail | RefreshToken
    | AssumeUser | AssumeUserSuccess | AssumeUserFail | AssumeUserInit | GetIdentityUsers | SetIdentityUsers | GetIdentityUsersFail
    | ResetPassword | ResetPasswordSuccess | ResetPasswordFail | RequestResetInit
    | RequestReset | RequestResetPasswordSuccess | RequestResetPasswordFail | AuthenticateTFAInit
    | AuthenticateTFA | AuthenticateTFASuccess | AuthenticateTFAFail | ChangePassword | ChangePasswordSuccess | ChangePasswordFail | ChangePasswordReset | Logout | LogoutSuccess;
